import { assertMatchesObjectShape } from './object/matches-object-shape';
import { assertRuntimeTypeOf, getRuntimeTypeOf, isRuntimeTypeOf } from './runtime-type-of';
export function parseJson({ jsonString, errorHandler, shapeMatcher, }) {
    try {
        const parsedJson = JSON.parse(jsonString);
        if (shapeMatcher != undefined) {
            if (isRuntimeTypeOf(shapeMatcher, 'object')) {
                assertMatchesObjectShape(parsedJson, shapeMatcher);
            }
            else {
                assertRuntimeTypeOf(parsedJson, getRuntimeTypeOf(shapeMatcher), 'parsedJson');
            }
        }
        return parsedJson;
    }
    catch (error) {
        if (errorHandler) {
            return errorHandler(error);
        }
        else {
            throw error;
        }
    }
}
